import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(props: OwnProps) {
  const { currentProperty } = props;

  if (!currentProperty) {
    return false;
  }

  return currentProperty.primaryHome !== null;
}

const step = {
  route: '/homeowners-insurance/quotes/property-use',
  isAccessible: ({ application: { isAutoOnly } }: OwnProps) => !isAutoOnly,
  breadcrumbStep: 'property',
  meetsDataDependencies,
};

export default step;
